import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip'; 
import DialogRoleNewSave from '../components/DialogRoleNewSave';
import DialogRoleEditSave from '../components/DialogRoleEditSave';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "./HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin'); 
	const childRefNewSave = React.useRef();
	const childRefEditSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState(""); 
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [dataLoading, setDataLoading] = React.useState(true);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [modules, setModules] = React.useState([]);

	const [open, setOpen] = React.useState(false);
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [authPrivileges, setAuthPrivileges] = React.useState({});
	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: '#', width: 40 },
		{ field: 'roleName', headerName: 'Role Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'description', headerName: 'Description', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), }
		/*
		{
		  field: 'age',
		  headerName: 'Age',
		  type: 'number',
		  width: 130,
		},
		{
		  field: 'fullName',
		  headerName: 'Full name',
		  description: 'This column has a value getter and is not sortable.',
		  sortable: false,
		  width: 160,
		  valueGetter: (params) =>
			`${params.getValue(params.id, 'firstName') || ''} ${
			  params.getValue(params.id, 'lastName') || ''
			}`,
		},
		*/
	  ];
	

	React.useEffect(() => {		
		if(userObj.emailId && userObj.token){
			getApiData(userObj.emailId,userObj.token,keyword);
		}
	}, [userObj,filter]);

	async function getApiData(emailId,token,keyword){
			axios.get(API_URL+'/admin-list-role?loginEmailId='+emailId+'&token='+token+"&keyword="+keyword)
			   .then(response => {
			 	///console.log("Just Checking >> "+response.data); 
				setDataLoading(false);
				if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.list);
					setAuthPrivileges(response.data.privileges);
				}			 		 				
			})
	}

	React.useEffect(() => {		
		if(userObj.emailId && userObj.token){
			getModulesApi(userObj.emailId,userObj.token);
		}
	}, [userObj]);

	async function getModulesApi(emailId,token){
		axios.get(API_URL+'/admin-roles-modules?loginEmailId='+emailId+'&token='+token)
		   .then(response => {
			 if(response.data.responseTxt==="success"){					 
				setModules(response.data.list);
			 }	 				
		})
	}
	
	function saveData(opt){
		if(opt===1){
			childRefNewSave.current.handleClickOpen();
		}else if(opt===2){
			childRefEditSave.current.handleClickOpen();
		}
	}
	
	function deleteData(){
		if(dataObj && userObj.emailId && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
			  		'token': userObj.token,
			  		'loginEmailId': userObj.emailId,
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  axios.post(API_URL+'/admin-delete-role', data, axiosHeader)
				.then((response) => {
					//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setOpen(false);
					setShowAlert(true);
					setAlertMessage("Role has been deleted.");
			  		window.location.reload();	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This role could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})	
		}		
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
		}
	}

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	

	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Roles</title>
          		</MetaTags>
				
				<Header title="Roles"  />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>

									<FormControl style={{width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop: -7}} size="small" variant="contained" color="secondary" >Search</Button>

									<span style={{marginTop:30}}>	
											{(authPrivileges && authPrivileges.create===1)?
												<i onClick={()=>{saveData(1)}} title="Create New Student" className="fa fa-plus-circle" style={{fontSize:30, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
										{selectedRow>0?<>
											{(authPrivileges && authPrivileges.update===1)?
												<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:30, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
											{(authPrivileges && authPrivileges.delete===1)?
												<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash" style={{fontSize:30, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}	
										</>:null}
									</span>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: 2150, width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}			
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No User found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			<DialogRoleNewSave modules={modules} ref={childRefNewSave} />
			<DialogRoleEditSave dataObj={dataObj} modules={modules} ref={childRefEditSave} />	

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete role.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>
					


		</div>	
	);
  }